// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    ChartColumnBig,
    ChartColumnDecreasing,
    ChartColumnIncreasing,
    ChartColumnStacked,
    ChartGantt,
    ChartLine,
    ChartNetwork,
    ChartNoAxesColumn,
    ChartNoAxesColumnDecreasing,
    ChartNoAxesColumnIncreasing,
    ChartNoAxesCombined,
    ChartNoAxesGantt,
    ChartPie,
    ChartScatter,
    ChartSpline,
    Check,
    CheckCheck,
    CheckLine,
    ChefHat,
    Cherry,
    ChessBishop,
    ChessKing,
    ChessKnight,
    ChessPawn,
    ChessQueen,
    ChessRook,
    ChevronDown,
    ChevronFirst,
    ChevronLast,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    ChevronsDown,
    ChevronsDownUp,
    ChevronsLeft,
    ChevronsLeftRight,
    ChevronsLeftRightEllipsis,
    ChevronsRight,
    ChevronsRightLeft,
    ChevronsUp,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "chart-column-big" through "chevrons-up", inclusive. */
const shard: Record<string, LucideIcon> = {
    "chart-column-big": ChartColumnBig,
    "chart-column-decreasing": ChartColumnDecreasing,
    "chart-column-increasing": ChartColumnIncreasing,
    "chart-column-stacked": ChartColumnStacked,
    "chart-gantt": ChartGantt,
    "chart-line": ChartLine,
    "chart-network": ChartNetwork,
    "chart-no-axes-column": ChartNoAxesColumn,
    "chart-no-axes-column-decreasing": ChartNoAxesColumnDecreasing,
    "chart-no-axes-column-increasing": ChartNoAxesColumnIncreasing,
    "chart-no-axes-combined": ChartNoAxesCombined,
    "chart-no-axes-gantt": ChartNoAxesGantt,
    "chart-pie": ChartPie,
    "chart-scatter": ChartScatter,
    "chart-spline": ChartSpline,
    check: Check,
    "check-check": CheckCheck,
    "check-line": CheckLine,
    "chef-hat": ChefHat,
    cherry: Cherry,
    "chess-bishop": ChessBishop,
    "chess-king": ChessKing,
    "chess-knight": ChessKnight,
    "chess-pawn": ChessPawn,
    "chess-queen": ChessQueen,
    "chess-rook": ChessRook,
    "chevron-down": ChevronDown,
    "chevron-first": ChevronFirst,
    "chevron-last": ChevronLast,
    "chevron-left": ChevronLeft,
    "chevron-right": ChevronRight,
    "chevron-up": ChevronUp,
    "chevrons-down": ChevronsDown,
    "chevrons-down-up": ChevronsDownUp,
    "chevrons-left": ChevronsLeft,
    "chevrons-left-right": ChevronsLeftRight,
    "chevrons-left-right-ellipsis": ChevronsLeftRightEllipsis,
    "chevrons-right": ChevronsRight,
    "chevrons-right-left": ChevronsRightLeft,
    "chevrons-up": ChevronsUp,
};

export default shard;
